import IndustryField from './IndustryField.component';

export default IndustryField;
